import { render, staticRenderFns } from "./CardPhoneNumberEditModal.vue?vue&type=template&id=36d5b4bc"
import script from "./CardPhoneNumberEditModal.vue?vue&type=script&lang=js"
export * from "./CardPhoneNumberEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports